var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98/\xEC\x82\xAC\xEC\xA7\x84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1379_1762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.681641,
    y: 0.0742188,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1379_1762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_photo_alternate_2",
    d: "M4.84831 17.5742C4.38997 17.5742 3.99761 17.411 3.67122 17.0846C3.34484 16.7582 3.18164 16.3659 3.18164 15.9076V4.24089C3.18164 3.78255 3.34484 3.39019 3.67122 3.0638C3.99761 2.73741 4.38997 2.57422 4.84831 2.57422H11.515V4.24089H4.84831V15.9076H16.515V9.24089H18.1816V15.9076C18.1816 16.3659 18.0184 16.7582 17.6921 17.0846C17.3657 17.411 16.9733 17.5742 16.515 17.5742H4.84831ZM5.68164 14.2409H15.6816L12.5566 10.0742L10.0566 13.4076L8.18164 10.9076L5.68164 14.2409ZM14.8483 7.57422V5.90755H13.1816V4.24089H14.8483V2.57422H16.515V4.24089H18.1816V5.90755H16.515V7.57422H14.8483Z",
    fill: "#B2B2B2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDescript);
export default __webpack_public_path__ + "static/media/imageDescript.91a47985ae42091b6b9d0684b8ec88ef.svg";
export { ForwardRef as ReactComponent };